/* Maison Sel Doré — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  const formatMoney = (cents, format = (window.theme && theme.moneyFormat) || '${{amount}}') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands = ',', dec = '.') => {
      const fixed = n.toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + dec + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2);
        case 'amount_no_decimals': return fmt(value, 0);
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2);
      }
    });
  };

  /* ---------- layers ---------- */
  // Drawers rendered inside the sticky header would be trapped in its stacking context
  // (below the scrim and announcement bar). Lift them to <body> so they sit on top.
  const liftLayers = () => {
    $$('.header-section [data-drawer], .header-section [data-search-panel]').forEach((el) => {
      $$(`body > #${el.id}`).forEach((old) => old.remove());
      document.body.appendChild(el);
    });
  };
  liftLayers();
  document.addEventListener('shopify:section:load', liftLayers);

  /* ---------- body lock + scrim ---------- */
  const scrim = $('[data-scrim]');
  let openLayer = null;
  let lastFocus = null;

  const showScrim = () => {
    if (!scrim) return;
    scrim.hidden = false;
    requestAnimationFrame(() => scrim.classList.add('is-visible'));
  };
  const hideScrim = () => {
    if (!scrim) return;
    scrim.classList.remove('is-visible');
    setTimeout(() => { if (!openLayer) scrim.hidden = true; }, 400);
  };

  const openDrawer = (el, trigger) => {
    if (!el) return;
    if (openLayer && openLayer !== el) closeLayer();
    lastFocus = trigger || document.activeElement;
    el.classList.add('is-open');
    openLayer = el;
    document.body.classList.add('is-locked');
    showScrim();
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = el.querySelector('button, a, input, select, textarea');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 60);
  };

  const closeLayer = () => {
    if (!openLayer) return;
    const el = openLayer;
    el.classList.remove('is-open');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openLayer = null;
    document.body.classList.remove('is-locked');
    hideScrim();
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.openDrawer), opener);
      return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.closest('[data-close-search]') || e.target === scrim) {
      closeLayer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeLayer();
      closeMegas();
    }
    if (e.key === 'Tab' && openLayer) {
      const items = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', openLayer)
        .filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header ---------- */
  const header = $('[data-header]');
  const announcement = $('[data-announcement]');
  const overlay = document.body.classList.contains('has-overlay-header');
  let megaOpen = false;
  let headerHover = false;

  const syncHeader = () => {
    if (!header) return;
    const annH = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--announce-h', annH + 'px');
    if (overlay) {
      document.documentElement.style.setProperty('--announce-offset', Math.max(0, annH - window.scrollY) + 'px');
      const solid = window.scrollY > 24 || megaOpen || headerHover || openLayer;
      header.classList.toggle('is-solid', Boolean(solid));
    }
  };
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { syncHeader(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', syncHeader);
  syncHeader();

  if (header && overlay) {
    header.addEventListener('mouseenter', () => { headerHover = true; syncHeader(); });
    header.addEventListener('mouseleave', () => { headerHover = false; syncHeader(); });
  }

  /* mega menu */
  const navItems = $$('[data-nav-item]');
  let megaTimer = null;
  const closeMegas = () => {
    navItems.forEach((i) => {
      i.classList.remove('is-open');
      const a = i.querySelector('.nav__link');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
    megaOpen = false;
    syncHeader();
  };
  const openMega = (item) => {
    navItems.forEach((i) => { if (i !== item) i.classList.remove('is-open'); });
    item.classList.add('is-open');
    const a = item.querySelector('.nav__link');
    if (a) a.setAttribute('aria-expanded', 'true');
    megaOpen = true;
    syncHeader();
  };
  navItems.forEach((item) => {
    item.addEventListener('mouseenter', () => { clearTimeout(megaTimer); megaTimer = setTimeout(() => openMega(item), 90); });
    item.addEventListener('mouseleave', () => { clearTimeout(megaTimer); megaTimer = setTimeout(closeMegas, 160); });
    item.addEventListener('focusin', () => openMega(item));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) closeMegas(); });
    const link = item.querySelector('.nav__link');
    if (link) {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          openMega(item);
        }
      });
    }
  });

  /* announcement rotation */
  if (announcement) {
    const items = $$('.announcement__item', announcement);
    if (items.length > 1 && !reduceMotion) {
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 5000);
    }
  }

  /* search */
  const searchPanel = $('[data-search-panel]');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]') && searchPanel) {
      e.preventDefault();
      openDrawer(searchPanel, e.target.closest('[data-open-search]'));
      const input = $('input[type=search]', searchPanel);
      if (input) setTimeout(() => input.focus(), 80);
    }
  });

  /* ---------- reveal on scroll ---------- */
  const revealTargets = $$('[data-reveal], [data-hero]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- membership (le cercle) ---------- */
  const member = (window.theme && theme.member) || {};
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } },
  };

  // Saving the member code to the cart: Shopify keeps a discount applied from /discount/CODE
  // and checkout honours it when the buyer's email belongs to the members segment.
  const applyMemberCode = () => {
    if (!member.code) return;
    try { if (sessionStorage.getItem('msd-member-code') === member.code) return; } catch (e) { /* ignore */ }
    fetch(`${theme.routes.root.replace(/\/$/, '')}/discount/${encodeURIComponent(member.code)}`, { credentials: 'same-origin' })
      .then(() => { try { sessionStorage.setItem('msd-member-code', member.code); } catch (e) { /* ignore */ } })
      .catch(() => {});
  };

  const memberModal = $('[data-member-modal]');
  const openMember = () => {
    if (!memberModal) return;
    lastFocus = document.activeElement;
    memberModal.hidden = false;
    requestAnimationFrame(() => memberModal.classList.add('is-open'));
    document.body.classList.add('is-locked');
    const field = $('input[type=email], .btn', memberModal);
    if (field) setTimeout(() => field.focus({ preventScroll: true }), 120);
  };
  const closeMember = () => {
    if (!memberModal || memberModal.hidden) return;
    memberModal.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    setTimeout(() => { memberModal.hidden = true; }, 350);
    if (store.get('msd-cercle') !== 'joined') store.set('msd-cercle', 'dismissed');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  const justJoined = /[?&]customer_posted=true/.test(window.location.search)
    && ($('[data-member-success]') || $('.newsletter .form-message--success'));

  if (justJoined) {
    store.set('msd-cercle', 'joined');
    applyMemberCode();
    if (memberModal && window.location.hash === '#MemberPopupForm') openMember();
  } else if (member.isMember) {
    store.set('msd-cercle', 'joined');
    applyMemberCode();
  } else if (memberModal && !store.get('msd-cercle') && !document.body.classList.contains('no-member-popup')) {
    setTimeout(() => { if (!openLayer) openMember(); }, (Number(memberModal.dataset.delay) || 7) * 1000);
  }

  if (memberModal) {
    memberModal.addEventListener('click', (e) => {
      if (e.target === memberModal || e.target.closest('[data-member-close]')) closeMember();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMember(); });
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-member]');
    if (trigger && memberModal && !member.isMember) {
      e.preventDefault();
      closeLayer();
      setTimeout(openMember, 200);
    }
  });

  /* ---------- collection sort ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- cart ---------- */
  const cartDrawer = () => $('[data-cart-drawer]');

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.dataset.count = count;
      el.textContent = count > 0 ? count : '';
    });
    $$('[data-cart-toggle]').forEach((a) => a.setAttribute('aria-label', `cart, ${count} items`));
  };

  const refreshDrawer = async () => {
    const res = await fetch(`${theme.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html);
    const current = cartDrawer();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  };

  const getCart = () => fetch(`${theme.routes.cart}.js`).then((r) => r.json());

  const openCart = async (trigger) => {
    const drawer = cartDrawer();
    if (!drawer) { window.location.href = theme.routes.cart; return; }
    openDrawer(drawer, trigger);
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && cartDrawer() && theme.cartDrawer) {
      e.preventDefault();
      openCart(toggle);
    }
  });

  const changeLine = async (line, quantity, inDrawer) => {
    const drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-busy');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      });
      const cart = await res.json();
      if ($('[data-cart-page]') && !inDrawer) { window.location.reload(); return; }
      updateCount(cart.item_count);
      await refreshDrawer();
    } finally {
      const d = cartDrawer();
      if (d) d.classList.remove('is-busy');
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    if (!line) return;
    e.preventDefault();
    changeLine(line.dataset.line, btn.dataset.qtyChange, Boolean(btn.closest('[data-cart-drawer]')));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const line = input.closest('[data-line]');
    changeLine(line.dataset.line, Math.max(0, parseInt(input.value, 10) || 0), Boolean(input.closest('[data-cart-drawer]')));
  });

  /* ---------- product ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const jsonEl = $('[data-product-json]');
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('[data-product-form]', productEl);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const addBtn = form ? $('[data-add-button]', form) : null;
    const addLabel = addBtn ? $('[data-add-label]', addBtn) : null;
    const errorEl = form ? $('[data-form-error]', form) : null;
    const stage = $('[data-stage]', productEl);
    const stageNote = $('[data-stage-note]', productEl);
    const priceValue = $('[data-price-value]', productEl);
    const buybar = $('[data-buybar]');
    const buybarPrice = buybar ? $('[data-buybar-price]', buybar) : null;
    const frames = () => $$('.framed', document).filter((f) => f.closest('[data-stage], .p-hero__thumb'));

    const selectedOptions = () => $$('fieldset[data-option-index]', form).map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const update = () => {
      if (!product) return;
      const opts = selectedOptions();
      const variant = findVariant(opts);

      $$('fieldset[data-option-index]', form).forEach((fs) => {
        const checked = $('input:checked', fs);
        const label = $('[data-option-value]', fs);
        if (checked && label) label.textContent = checked.value.replace(/\.00(?!\d)/, '');
        if (checked && checked.dataset.frameKey) frames().forEach((f) => { f.dataset.frame = checked.dataset.frameKey; });
        if (checked && checked.dataset.mountKey) frames().forEach((f) => { f.dataset.mount = checked.dataset.mountKey; });
        if (checked && checked.dataset.sizeIndex !== undefined && stage) {
          stage.dataset.sizeIndex = checked.dataset.sizeIndex;
          if (stageNote) stageNote.textContent = checked.value;
        }
      });

      if (errorEl) errorEl.hidden = true;
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'unavailable';
        return;
      }
      idInput.value = variant.id;
      // whole prices read cleaner without cents, matching money_without_trailing_zeros in Liquid
      const price = formatMoney(variant.price).replace(/[.,]00(?!\d)/, '');
      if (priceValue) priceValue.textContent = price;
      if (buybarPrice) buybarPrice.textContent = price;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? `add to cart · ${price}` : 'sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    if (form) form.addEventListener('change', (e) => { if (e.target.matches('input[type=radio]')) update(); });

    if (form && theme.cartDrawer) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        try {
          const res = await fetch(`${theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await res.json();
          if (data.status) {
            if (errorEl) { errorEl.textContent = data.description || data.message; errorEl.hidden = false; }
            return;
          }
          const cart = await getCart();
          updateCount(cart.item_count);
          await refreshDrawer();
          openCart(addBtn);
        } catch (err) {
          form.submit();
        } finally {
          addBtn.classList.remove('is-loading');
        }
      });
    }

    /* description clamp */
    const desc = $('[data-desc]', productEl);
    const descToggle = $('[data-desc-toggle]', productEl);
    if (desc && descToggle) {
      requestAnimationFrame(() => {
        if (desc.scrollHeight > desc.clientHeight + 4) descToggle.hidden = false;
        else desc.classList.remove('is-clamped');
      });
      descToggle.addEventListener('click', () => {
        const clamped = desc.classList.toggle('is-clamped');
        descToggle.textContent = clamped ? 'read more' : 'read less';
      });
    }

    /* mobile buy bar */
    if (buybar && addBtn && 'IntersectionObserver' in window) {
      const bio = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', show);
        buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
        const btn = $('[data-buybar-add]', buybar);
        if (btn) btn.tabIndex = show ? 0 : -1;
      });
      bio.observe(addBtn);
      $('[data-buybar-add]', buybar).addEventListener('click', () => {
        addBtn.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        setTimeout(() => addBtn.focus({ preventScroll: true }), 400);
      });
    }

    /* recommendations */
    const rec = $('[data-recommendations]');
    if (rec && rec.dataset.url) {
      fetch(rec.dataset.url).then((r) => r.text()).then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = $('[data-recommendations]', html);
        if (fresh && fresh.innerHTML.trim()) rec.innerHTML = fresh.innerHTML;
      }).catch(() => {});
    }
  }

  /* ---------- detail zoom ---------- */
  const zoomEl = $('[data-zoom]');
  if (zoomEl) {
    const viewport = $('[data-zoom-viewport]', zoomEl);
    const img = $('[data-zoom-img]', zoomEl);
    const levelEl = $('[data-zoom-level]', zoomEl);
    let s = 1, tx = 0, ty = 0, maxS = 4, opener = null;
    const pointers = new Map();
    let pinch = null, drag = null, moved = false, lastTap = 0;

    const fit = () => ({ w: img.offsetWidth, h: img.offsetHeight, vw: viewport.clientWidth, vh: viewport.clientHeight });
    const clamp = () => {
      const f = fit();
      const mx = Math.max(0, (f.w * s - f.vw) / 2 + 24), my = Math.max(0, (f.h * s - f.vh) / 2 + 24);
      tx = Math.min(mx, Math.max(-mx, tx)); ty = Math.min(my, Math.max(-my, ty));
      if (s <= 1.001) { tx = 0; ty = 0; }
    };
    const render = (animate) => {
      clamp();
      img.classList.toggle('is-animating', !!animate);
      img.style.transform = `translate(-50%, -50%) translate(${tx}px, ${ty}px) scale(${s})`;
      viewport.classList.toggle('is-zoomed', s > 1.01);
      if (levelEl) levelEl.textContent = Math.round(s * 100) + '%';
    };
    // zoom to "next" keeping the image point under (px, py) fixed; px/py are relative to the viewport centre
    const zoomTo = (next, px = 0, py = 0, animate = true) => {
      next = Math.min(maxS, Math.max(1, next));
      const ux = (px - tx) / s, uy = (py - ty) / s;
      s = next; tx = px - ux * s; ty = py - uy * s;
      render(animate);
    };
    const toCentre = (e) => { const r = viewport.getBoundingClientRect(); return [e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2]; };
    const updateMax = () => { const f = fit(); maxS = Math.max(2.5, Math.min(8, (img.naturalWidth || +img.getAttribute('width')) / Math.max(1, f.w))); };

    const open = (from) => {
      opener = from || null;
      if (!img.getAttribute('src')) {
        img.src = img.dataset.preview;
        const full = new Image();
        full.onload = () => { img.src = img.dataset.full; updateMax(); };
        full.src = img.dataset.full;
      }
      zoomEl.hidden = false;
      document.documentElement.classList.add('zoom-open');
      s = 1; tx = 0; ty = 0; render(false);
      requestAnimationFrame(updateMax);
      $('[data-zoom-close]', zoomEl).focus();
    };
    const close = () => {
      zoomEl.hidden = true;
      document.documentElement.classList.remove('zoom-open');
      if (opener) opener.focus();
    };

    $$('[data-zoom-open]').forEach((b) => b.addEventListener('click', () => open(b)));
    const stageArt = $('.product__stage .framed__art');
    if (stageArt) stageArt.addEventListener('click', () => open($('[data-zoom-open]')));
    $('[data-zoom-close]', zoomEl).addEventListener('click', close);
    $$('[data-zoom-step]', zoomEl).forEach((b) => b.addEventListener('click', () => zoomTo(s * (b.dataset.zoomStep === '1' ? 1.6 : 1 / 1.6))));
    document.addEventListener('keydown', (e) => {
      if (zoomEl.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === '+' || e.key === '=') zoomTo(s * 1.6);
      if (e.key === '-') zoomTo(s / 1.6);
    });
    img.addEventListener('load', updateMax);
    window.addEventListener('resize', () => { if (!zoomEl.hidden) { updateMax(); render(false); } });

    viewport.addEventListener('wheel', (e) => {
      e.preventDefault();
      const [px, py] = toCentre(e);
      zoomTo(s * Math.exp(-e.deltaY * 0.0022), px, py, false);
    }, { passive: false });

    viewport.addEventListener('pointerdown', (e) => {
      viewport.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, e);
      moved = false;
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        pinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY), s };
        drag = null;
      } else {
        drag = { x: e.clientX, y: e.clientY, tx, ty };
      }
    });
    viewport.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, e);
      if (pinch && pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        const d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const r = viewport.getBoundingClientRect();
        zoomTo(pinch.s * (d / pinch.d), (a.clientX + b.clientX) / 2 - r.left - r.width / 2, (a.clientY + b.clientY) / 2 - r.top - r.height / 2, false);
        moved = true;
      } else if (drag && s > 1.01) {
        const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 3) { moved = true; viewport.classList.add('is-dragging'); }
        tx = drag.tx + dx; ty = drag.ty + dy;
        render(false);
      }
    });
    const end = (e) => {
      pointers.delete(e.pointerId);
      viewport.classList.remove('is-dragging');
      if (pointers.size < 2) pinch = null;
      if (pointers.size === 1) { const p = [...pointers.values()][0]; drag = { x: p.clientX, y: p.clientY, tx, ty }; } else { drag = null; }
    };
    viewport.addEventListener('pointerup', (e) => {
      const wasMoved = moved;
      end(e);
      if (wasMoved || e.button > 0) return;
      // tap or click: zoom in on the spot, or back out when already in
      const now = Date.now();
      const [px, py] = toCentre(e);
      if (e.pointerType === 'touch') {
        if (now - lastTap < 320) { zoomTo(s > 1.01 ? 1 : 2.5, px, py); lastTap = 0; } else { lastTap = now; }
      } else {
        zoomTo(s > 1.01 ? 1 : 2.5, px, py);
      }
    });
    viewport.addEventListener('pointercancel', end);
  }
})();
